<template>
<div class="panel" id="login-panel" @keyup.enter="login">
    <div class="panel-title">
        Connexion
        <hr>
    </div>
    <div class="panel-content">
        <div class="form-group">
            <input  v-model="username"
                    type="text"
                    class="form-control"
                    id="username"
                    placeholder="Identifiant">
        </div>
        <div class="form-group">
            <input  v-model="password"
                    type="password"
                    class="form-control"
                    id="password"
                    placeholder="Mot de passe">
        </div>
        <div v-if="hasErrors" class="row columns">
            <div id="login_error" class="login-error">
            {{error}}
            </div>
        </div>
        <div v-if="loginError" class="row columns">
            <div id="login_error" class="login-error">
            Impossible de se connecter
            </div>
        </div>
        <br>
        <div class="row">
            <div class="large-centered large-5">
              <button id="login-btn" @click="login" class="full-width">Se Connecter</button>
            </div>
        </div>
        <div class="row">
            <br>
            <div class="small-10 small-centered ">
                <router-link id="lostlogin-link" to="lostLogin" class="small-link">j'ai perdu mon mot de passe</router-link>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import store from '../../store/index.js'
import { mapGetters } from 'vuex'

export default {
  name: 'loginPanel',
  computed: {
    ...mapGetters([
      'loginError'
    ])
  },
  methods: {
    login () {
      this.error = ''
      this.hasErrors = false
      if (this.username === '') {
        this.hasErrors = true
        this.error = 'le nom d\'utilisateur est obligatoire, champion'
      } else if (this.password === '') {
        this.hasErrors = true
        this.error = 'le mot de passe ? non ? jamais ?'
      } else {
        store.dispatch('logUser', [this.username, this.password])
      }
    }
  },
  data () {
    return {
      username: '',
      hasErrors: false,
      password: ''
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-error {
  text-align: center;
  color: #CC0000;
}
</style>



// WEBPACK FOOTER //
// login-panel.vue?bf9b30dc